<script>
export default {
  props: {
    colors: {
      type: Array,
      required: true,
    },
    selectedColor: {
      type: String,
      default: '',
    },
    colorLabel: {
      type: String,
      required: true,
    },
  },
  emits: ['newSelected'],
  methods: {
    colorClass(color) {
      return `product-color__variant--${color}`;
    },
  },
};
</script>

<template>
  <div class="product-color__container">
    <div class="product-color__label">
      {{colorLabel}}
    </div>
    <div class="product-color__variant-list">
      <div
        :class="[
          'product-color__variant',
          {'product-color__variant--selected'
            : selectedColor == color.value},
          colorClass(color.value)
        ]"
        v-for="color in colors"
        :key="color.value"
        :style="{'background': color.value}"
        @click="$emit('newSelected', color.value)"
      >
      </div>
    </div>
  </div>
</template>

<style>
  .product-color__container {
    margin: 14px 0;
  }

  .product-color__label {
    font-size: var(--size-xxs);
    line-height: var(--size-xs);
    letter-spacing: 0.015em;
    margin-bottom: 10px;
  }

  .product-color__variant-list {
    display: flex;
    gap: 10px;
    align-items: center;
  }

  .product-color__variant {
    height: 20px;
    width: 20px;
    border-radius: 50%;
    filter: saturate(70%);
    position: relative;
    cursor: pointer;
  }

  .product-color__variant--selected {
    pointer-events: none;
    user-select: none;
    cursor: default;
  }

  .product-color__variant--selected::before {
    content: '';
    border-radius: 50%;
    position: absolute;
    inset: -3px;
    border: 1px solid var(--color-main-90);
  }

  .product-color__variant--white {
    box-shadow: 0 0 1px 1px black;
  }

  .product-color__variant--bronze {
    background: rgb(223,95,24);
    background: linear-gradient(90deg, rgba(223,95,24,1) 0%,
      rgba(255,175,96,1) 36%, rgba(218,82,0,1) 100%);
  }

  .product-color__variant--metal {
    background: rgb(126,126,126);
    background: linear-gradient(90deg, rgba(126,126,126,1) 0%,
      rgba(204,203,203,1) 36%, rgba(139,139,139,1) 100%);
  }

  @media (--tabletAndDesktop) {
    .product-color__variant--selected::before {
      inset: -4px;
    }
  }
</style>
